<template>
  <div class="expandable-items">
    <div class="box">
      <div>
        <div :class="['title', titleColor]">{{ title }}</div>
      </div>
      <expandable-item v-for="item in items" v-bind:key="item.title" v-on:expanded="onItemExpanded(item.title)"
                       :title="item.title" :content="item.content" >
      </expandable-item>
    </div>
  </div>
</template>

<script>

import ExpandableItem from './ExpandableItem.vue';

export default {
  name: 'ExpandableItems',
  components: {
    ExpandableItem,
  },
  props: {
    title: String,
    items: Array,
    titleColor: String,
    onItemExpanded: {
      type: Function,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../node_modules/base-ui/src/scss/riseup-colors';

  .expandable-items {
    padding: 16px 20px;
  }

  .box {
    box-shadow: 0 2px 3px 0 rgba(155, 155, 155, 0.51);
  }

  .title {
    border-bottom: solid 1px;
    width: 100%;
    height: 32px;
    font-size: 12px;
    line-height: 1;
    padding: 10px 22px 2px 16px;
    font-family: SimplerProBold;

    &.mustard {
      color: $riseup_yellow;
      border-bottom-color: $riseup_yellow;
    }

    &.green {
      color: $riseup_green;
      border-bottom-color: $riseup_green;
    }

    &.red {
      color: $riseup_red;
      border-bottom-color: $riseup_red;
    }

    &.blue {
      color: $riseup_blue;
      border-bottom-color: $riseup_blue;
    }
  }
</style>
